import { BondType } from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { AssignBeneficiaryDto, Bond, Bonds } from 'service/dto/bond.dto';
import { BeneficiariesAllocationDto } from 'service/dto/general.dto';
import { errorHandler } from 'utils';

class BondService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createBond = async (bondType: BondType) => {
    try {
      const response = await this.baseService.post('/bond/create', bondType);
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getBonds = async (): Promise<Bonds> => {
    try {
      const response = await this.baseService.get('/bond');
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteBond = async (bondId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(`/bond/${bondId}`);
      return response.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignBeneficiary = async (assignBeneficiaryDto: AssignBeneficiaryDto) => {
    try {
      const response = await this.baseService.patch(
        '/bond/assign-to-beneficiary',
        assignBeneficiaryDto
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getBond = async (bondId: number): Promise<Bond> => {
    try {
      const response = await this.baseService.get(`/bond/${bondId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  unAssignBondBeneficiary = async (allocationId?: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/bond/unassign-beneficiary/${allocationId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  editBulkBondBeneficiary = async (
    beneficiariesAllocationDto?: BeneficiariesAllocationDto
  ): Promise<void> => {
    try {
      const response = await this.baseService.patch(
        `/bond/bulk-edit-beneficiary-assign`,
        beneficiariesAllocationDto
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  removeBondTrustee = async (
    assetId: number,
    trusteeId: number
  ): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/bond/unassign-trustee/${assetId}/${trusteeId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignBondTrustee = async (
    assetId: number[],
    trusteeId: number,
    note: string
  ): Promise<void> => {
    try {
      const response = await this.baseService.put(`/bond/assign/bulk-trustee`, {
        assetId,
        trusteeId,
        note
      });
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default BondService;
